import { Input, Typography } from 'antd'
import styled from 'styled-components'

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const Label = styled(Typography.Text)`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
`

export const StyledInput = styled(Input)`
  && {
    background-color: ${(props) => props.theme.colors.white} !important;
    border-color: ${(props) => props.theme.colors.borderInput};
    padding-left: 8px;
    padding-right: 12px;
    border-radius: 6px;

    input {
      text-overflow: ellipsis;
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.white} !important;
    }

    &:focus-within {
      background-color: ${(props) => props.theme.colors.white} !important;
      border-color: transparent !important;
      box-shadow: inset 0 0 0 2px
        ${(props) => props.theme.colors.borderInputFocus} !important;

      .ant-input {
        background-color: ${(props) => props.theme.colors.white} !important;
      }
    }

    &.ant-input-status-success:not(.ant-input-disabled):not(:focus-within) {
      border-color: ${(props) => props.theme.colors.success} !important;
    }

    &.ant-input-disabled {
      background-color: ${(props) => props.theme.colors.background} !important;
    }
  }
`

export const StyledPasswordInput = styled(Input.Password)`
  && {
    background-color: ${(props) => props.theme.colors.white} !important;
    border-color: ${(props) => props.theme.colors.borderInput};
    padding-left: 8px;
    padding-right: 12px;

    .ant-input {
      background-color: ${(props) => props.theme.colors.white} !important;
    }

    &:hover {
      background-color: ${(props) => props.theme.colors.white} !important;

      .ant-input {
        background-color: ${(props) => props.theme.colors.white} !important;
      }
    }

    &:focus-within {
      background-color: ${(props) => props.theme.colors.white} !important;
      border-color: transparent !important;
      box-shadow: inset 0 0 0 2px
        ${(props) => props.theme.colors.borderInputFocus} !important;

      .ant-input {
        background-color: ${(props) => props.theme.colors.white} !important;
      }
    }

    &.ant-input-status-success:not(.ant-input-disabled):not(:focus-within) {
      border-color: ${(props) => props.theme.colors.success} !important;
    }

    &.ant-input-password-disabled {
      background-color: ${(props) => props.theme.colors.background} !important;

      .ant-input {
        background-color: ${(props) =>
          props.theme.colors.background} !important;
      }
    }
  }
`
